import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../store"; // Pfad anpassen
// import userSession from "../../hooks/app/userSession.ts.old";
import ormStationsService from "../../hooks/api/stations";

export interface StationsState {}

export interface Opentime {
  day_of_week: string;
  times: string[]; // Array von Zeitspannen, z.B. ["07:30 - 12:30"]
}

export interface Station {
  id: string;
  name: string;
  street: string;
  zipcode: string;
  city: string;
  country: string | null;
  phone: string;
  fax: string;
  email: string;
  opening_date: string | null;
  is_sharing_station: boolean;
  is_rent_station: boolean;
  latitude: number;
  longitude: number;
  is_one_way_station: boolean | null;
  pickup_and_delivery_is_enabled: boolean | null;
  is_special: boolean;
  branch: string | null;
  is_auto_abo_station: boolean;
  opentimes: Opentime[];
  business_area: string | null;
  hide_online_payment: boolean | null;
  closing_date: string | null;
  min_forward_time: number;
}

const initialState: any = {
  stations: [] as Station[],
  selectedStation: {} as Station,
  selectedStationEnd: {} as Station,
  openingtimes: {} as any,
  // startDate: "",
  // endDate: "",
  // startTime: "",
  // endtime: "",
};

export const ormstationsSlice = createSlice({
  name: "ormstations",
  initialState,
  reducers: {
    setStationsAndPreselect: (
      state,
      action: PayloadAction<{
        stations: Station[];
        preselectedId?: string;
        shouldPreselect: boolean;
      }>,
    ) => {
      state.stations = action.payload.stations;

      if (action.payload.shouldPreselect) {
        if (action.payload.preselectedId) {
          state.selectedStation = state.stations.find(
            (station: Station) => station.id === action.payload.preselectedId,
          );
        } else {
          state.selectedStation = state.stations[0];
        }
      }
    },
    setStations: (state, action: PayloadAction<any[]>) => {
      state.stations = action.payload;
    },
    preselectStation: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        state.selectedStation = state.stations.find(
          (station: Station) => station.id === action.payload,
        );
      } else {
        state.selectedStation = state.stations[0];
      }
    },
    // setSelectedStation: (state, action: PayloadAction<any>) => {
    //   if (action.payload.type === "start") {
    //     state.selectedStation = action.payload.station;
    //     userSession.setUserSession(
    //       "selectedStation",
    //       action.payload.station.id,
    //     );
    //   } else {
    //     state.selectedStationEnd = action.payload;
    //     userSession.setUserSession(
    //       "selectedStationEnd",
    //       action.payload.station.id,
    //     );
    //   }
    //   ormStationsService.fetchOpeningTimes();
    // },
    setOpeningtimes: (state, action: PayloadAction<any>) => {
      state.openingtimes = action.payload;
    },
    // setStartDate: (state, action: PayloadAction<any>) => {
    //   state.startDate = action.payload;
    // },
    // setEndDate: (state, action: PayloadAction<any>) => {
    //   state.endDate = action.payload;
    // },
    // setStartTime: (state, action: PayloadAction<any>) => {
    //   state.startTime = action.payload;
    // },
    // setEndTime: (state, action: PayloadAction<any>) => {
    //   state.endTime = action.payload;
    // },
  },
});

export const getStationById = (state: RootState, stationId: string) => {
  if (state.stations.stations) {
    return state.stations.stations.find(
      (station: Station) => station.id === stationId,
    ) as Station;
  } else {
    return null;
  }
};

export const {
  setStations,
  // setSelectedStation,
  preselectStation,

  setStationsAndPreselect,
  setOpeningtimes,
  // setStartDate,
  // setEndDate,
  // setStartTime,
  // setEndTime,
} = ormstationsSlice.actions;

export default ormstationsSlice.reducer;
